import React, { useEffect } from 'react';

// Simple in-page image popup. Renders nothing when `src` is falsy.
// Close on backdrop click, the × button, or the Escape key.
export default function ImageLightbox({ src, onClose }) {
  useEffect(() => {
    if (!src) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    // Prevent the page scrolling behind the popup.
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [src, onClose]);

  if (!src) return null;

  return (
    <div className="fixed inset-0 bg-black/80 z-[70] flex items-center justify-center p-4"
         onClick={onClose}>
      <img src={src} alt="Büyütülmüş görsel"
           className="max-w-full max-h-[90vh] rounded-lg shadow-2xl object-contain"
           onClick={(e) => e.stopPropagation()} />
      <button onClick={onClose} aria-label="Kapat"
              className="absolute top-4 right-5 text-white/90 hover:text-white text-4xl leading-none">×</button>
    </div>
  );
}
